import { Ajax } from "../utils/base";
import IP from "../config/config"
export function worldCuplIndex (params) {
    const url = IP.mApis() + '/passport/activity/world-cup/index';
    return Ajax(url, params, "GET")
}
export function worldCupRaffle (params) {
    const url = IP.mApis() + '/passport/activity/world-cup/raffle';
    return Ajax(url, params, "POST")
}
export function getUserInfo (params) {
    const url = IP.passportApis() + '/user/info';
    return Ajax(url, params, "GET")
}
export function getListCouponArticle (params) {
    const url = IP.mApis() + '/news/article/list/coupon';
    return Ajax(url, params, "GET")
}
export function getListCouponChat (params) {
    const url = IP.mApis() + '/news/chat/list/coupon';
    return Ajax(url, params, "GET")
}
export function rechargeClick (params) {
    const url = IP.mApis() + '/passport/activity/world-cup/recharge-click';
    return Ajax(url, params, "POST")
}
// 欧洲杯理解对比
export function getCupEuropeDataCalc (params) {
    const url = IP.mApis() + '/api/home/activity/his-statis';
    return Ajax(url, params, "GET")
}
